import React from 'react';
import Modal from '@omilia/modal';

// @ts-ignore
import messages from 'constants/messages';
import ModalLoader from '../ModalLoader';

type Props = {
  branchName: string;
};

const CheckMergeBranchLoadingModal = ({ branchName }: Props) => (
  <Modal
    open
    data-test="version-control-modal"
    glyph="merge"
    hasBackdrop={false}
    subtitle={`${branchName} into its parent branch`}
    title="Merge Branch"
  >
    <ModalLoader
      text={messages.VERSION_CONTROL.MERGE_MODAL.CHECKING_MERGE_PARENT}
    />
  </Modal>
);

export default CheckMergeBranchLoadingModal;
